import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';

import { AssetsUrlPipe } from '@core/pipes'
import { SpinnerService } from '@core/services/spinner.service';
import { SocialHeaderComponent, SpinnerComponent } from '@ui/shared';

@Component({
    selector: 'app-root',
    standalone: true,
    templateUrl: './root.component.html',
    styleUrl: './root.component.scss',
    imports: [
        CommonModule, 
        RouterOutlet,
        SocialHeaderComponent, 
        AssetsUrlPipe,
        SpinnerComponent,
    ],
})
export class RootComponent {

    title = 'edl3c';

    constructor(public spinner: SpinnerService) {}
}
